import { render } from "./DetailStepServices.vue?vue&type=template&id=22f3c368"
import script from "./DetailStepServices.vue?vue&type=script&lang=js"
export * from "./DetailStepServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__